import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7502b8d6")

_pushScopeId("data-v-7502b8d6")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "desktop-content" }
const _hoisted_3 = { class: "mobile-content" }
const _hoisted_4 = { class: "desktop-content" }
const _hoisted_5 = { class: "pagination" }
const _hoisted_6 = { class: "mobile-content" }
const _hoisted_7 = {
  class: "pagination",
  style: {"overflow":"scroll"}
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "desktop-content" }
const _hoisted_10 = { class: "mobile-content" }
const _hoisted_11 = { class: "desktop-content" }
const _hoisted_12 = { class: "pagination" }
const _hoisted_13 = { class: "mobile-content" }
const _hoisted_14 = {
  class: "pagination",
  style: {"overflow":"scroll"}
}
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { class: "desktop-content" }
const _hoisted_17 = { class: "mobile-content" }
const _hoisted_18 = { class: "desktop-content" }
const _hoisted_19 = { class: "pagination" }
const _hoisted_20 = { class: "mobile-content" }
const _hoisted_21 = {
  class: "pagination",
  style: {"overflow":"scroll"}
}
const _hoisted_22 = { key: 3 }
const _hoisted_23 = { class: "desktop-content" }
const _hoisted_24 = { class: "mobile-content" }
const _hoisted_25 = { class: "desktop-content" }
const _hoisted_26 = { class: "pagination" }
const _hoisted_27 = { class: "mobile-content" }
const _hoisted_28 = { class: "pagination" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_radio_button = _resolveComponent("el-radio-button")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_SyncErrorsOrderTable = _resolveComponent("SyncErrorsOrderTable")
  const _component_SyncErrorsOrderListMobile = _resolveComponent("SyncErrorsOrderListMobile")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_SyncErrorsShipmentTable = _resolveComponent("SyncErrorsShipmentTable")
  const _component_SyncErrorsShipmentListMobile = _resolveComponent("SyncErrorsShipmentListMobile")
  const _component_SyncErrorsRefundTable = _resolveComponent("SyncErrorsRefundTable")
  const _component_SyncErrorsProductTable = _resolveComponent("SyncErrorsProductTable")
  const _component_SyncErrorsProductListMobile = _resolveComponent("SyncErrorsProductListMobile")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_el_radio_group, {
      modelValue: _ctx.activeName,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeName = $event)),
      fill: "#1fb8b5"
    }, {
      default: _withId(() => [
        _createVNode(_component_el_radio_button, { label: "Order" }),
        _createVNode(_component_el_radio_button, { label: "Product" }),
        _createVNode(_component_el_radio_button, { label: "Shipment" }),
        _createVNode(_component_el_radio_button, { label: "Refund" })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.activeName === 'Order')
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", null, [
            _createVNode("div", _hoisted_2, [
              _createVNode(_component_SyncErrorsOrderTable, {
                listData: _ctx.orderSyncErrorList,
                onSearch: _ctx.handleSearchOrder
              }, null, 8, ["listData", "onSearch"])
            ]),
            _createVNode("div", _hoisted_3, [
              _createVNode(_component_SyncErrorsOrderListMobile, {
                listData: _ctx.orderSyncErrorList,
                onSearch: _ctx.handleSearchOrder
              }, null, 8, ["listData", "onSearch"])
            ])
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_el_pagination, {
                background: "",
                "page-sizes": [20, 50, 100],
                "page-size": _ctx.perPage,
                "current-page": _ctx.currentOrderPage,
                layout: "total, prev, pager, next, sizes, jumper",
                total: _ctx.totalOrderRows,
                onCurrentChange: _ctx.handleCurrentChange,
                onSizeChange: _ctx.handleSizeChange,
                onPrevClick: ($event: any) => (1)
              }, null, 8, ["page-size", "current-page", "total", "onCurrentChange", "onSizeChange"])
            ])
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_el_pagination, {
                background: "",
                small: "",
                "page-sizes": [20, 50, 100],
                "page-size": _ctx.perPage,
                "current-page": _ctx.currentOrderPage,
                layout: "pager, sizes",
                total: _ctx.totalOrderRows,
                onCurrentChange: _ctx.handleCurrentChange,
                onSizeChange: _ctx.handleSizeChange,
                onPrevClick: ($event: any) => (1)
              }, null, 8, ["page-size", "current-page", "total", "onCurrentChange", "onSizeChange"])
            ])
          ])
        ]))
      : (_ctx.activeName === 'Shipment')
        ? (_openBlock(), _createBlock("div", _hoisted_8, [
            _createVNode("div", null, [
              _createVNode("div", _hoisted_9, [
                _createVNode(_component_SyncErrorsShipmentTable, {
                  listData: _ctx.shipmentSyncErrorList,
                  onSearch: _ctx.handleSearchShipment
                }, null, 8, ["listData", "onSearch"])
              ]),
              _createVNode("div", _hoisted_10, [
                _createVNode(_component_SyncErrorsShipmentListMobile, {
                  listData: _ctx.shipmentSyncErrorList,
                  onSearch: _ctx.handleSearchShipment
                }, null, 8, ["listData", "onSearch"])
              ])
            ]),
            _createVNode("div", _hoisted_11, [
              _createVNode("div", _hoisted_12, [
                _createVNode(_component_el_pagination, {
                  background: "",
                  "page-sizes": [20, 50, 100],
                  "page-size": _ctx.perPage,
                  "current-page": _ctx.currentShipmentPage,
                  layout: "total, prev, pager, next, sizes, jumper",
                  total: _ctx.totalShipmentRows,
                  onCurrentChange: _ctx.handleCurrentChange,
                  onSizeChange: _ctx.handleSizeChange,
                  onPrevClick: ($event: any) => (1)
                }, null, 8, ["page-size", "current-page", "total", "onCurrentChange", "onSizeChange"])
              ])
            ]),
            _createVNode("div", _hoisted_13, [
              _createVNode("div", _hoisted_14, [
                _createVNode(_component_el_pagination, {
                  background: "",
                  small: "",
                  "page-sizes": [20, 50, 100],
                  "page-size": _ctx.perPage,
                  "current-page": _ctx.currentShipmentPage,
                  layout: "pager, sizes",
                  total: _ctx.totalShipmentRows,
                  onCurrentChange: _ctx.handleCurrentChange,
                  onSizeChange: _ctx.handleSizeChange,
                  onPrevClick: ($event: any) => (1)
                }, null, 8, ["page-size", "current-page", "total", "onCurrentChange", "onSizeChange"])
              ])
            ])
          ]))
        : (_ctx.activeName === 'Refund')
          ? (_openBlock(), _createBlock("div", _hoisted_15, [
              _createVNode("div", null, [
                _createVNode("div", _hoisted_16, [
                  _createVNode(_component_SyncErrorsRefundTable, {
                    listData: _ctx.refundSyncErrorList,
                    onSearch: _ctx.handleSearchRefund
                  }, null, 8, ["listData", "onSearch"])
                ]),
                _createVNode("div", _hoisted_17, [
                  _createVNode(_component_SyncErrorsRefundTable, {
                    listData: _ctx.refundSyncErrorList,
                    onSearch: _ctx.handleSearchRefund
                  }, null, 8, ["listData", "onSearch"])
                ])
              ]),
              _createVNode("div", _hoisted_18, [
                _createVNode("div", _hoisted_19, [
                  _createVNode(_component_el_pagination, {
                    background: "",
                    "page-sizes": [20, 50, 100],
                    "page-size": _ctx.perPage,
                    "current-page": _ctx.currentRefundPage,
                    layout: "total, prev, pager, next, sizes, jumper",
                    total: _ctx.totalRefundRows,
                    onCurrentChange: _ctx.handleCurrentChange,
                    onSizeChange: _ctx.handleSizeChange,
                    onPrevClick: ($event: any) => (1)
                  }, null, 8, ["page-size", "current-page", "total", "onCurrentChange", "onSizeChange"])
                ])
              ]),
              _createVNode("div", _hoisted_20, [
                _createVNode("div", _hoisted_21, [
                  _createVNode(_component_el_pagination, {
                    background: "",
                    small: "",
                    "page-sizes": [20, 50, 100],
                    "page-size": _ctx.perPage,
                    "current-page": _ctx.currentRefundPage,
                    layout: "pager, sizes",
                    total: _ctx.totalRefundRows,
                    onCurrentChange: _ctx.handleCurrentChange,
                    onSizeChange: _ctx.handleSizeChange,
                    onPrevClick: ($event: any) => (1)
                  }, null, 8, ["page-size", "current-page", "total", "onCurrentChange", "onSizeChange"])
                ])
              ])
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_22, [
              _createVNode("div", null, [
                _createVNode("div", _hoisted_23, [
                  _createVNode(_component_SyncErrorsProductTable, {
                    listData: _ctx.productSyncErrorList,
                    onFinishHandle: _ctx.handleAfter,
                    onSearch: _ctx.handleSearchProduct
                  }, null, 8, ["listData", "onFinishHandle", "onSearch"])
                ]),
                _createVNode("div", _hoisted_24, [
                  _createVNode(_component_SyncErrorsProductListMobile, {
                    listData: _ctx.productSyncErrorList,
                    onFinishHandle: _ctx.handleAfter,
                    onSearch: _ctx.handleSearchProduct
                  }, null, 8, ["listData", "onFinishHandle", "onSearch"])
                ])
              ]),
              _createVNode("div", _hoisted_25, [
                _createVNode("div", _hoisted_26, [
                  _createVNode(_component_el_pagination, {
                    background: "",
                    "page-sizes": [20, 50, 100],
                    "page-size": _ctx.perPage,
                    "current-page": _ctx.currentProductPage,
                    layout: "total, prev, pager, next, sizes, jumper",
                    total: _ctx.totalProductRows,
                    onCurrentChange: _ctx.handleCurrentChange,
                    onSizeChange: _ctx.handleSizeChange,
                    onPrevClick: ($event: any) => (1)
                  }, null, 8, ["page-size", "current-page", "total", "onCurrentChange", "onSizeChange"])
                ])
              ]),
              _createVNode("div", _hoisted_27, [
                _createVNode("div", _hoisted_28, [
                  _createVNode(_component_el_pagination, {
                    small: "",
                    background: "",
                    "page-sizes": [20, 50, 100],
                    "page-size": _ctx.perPage,
                    "current-page": _ctx.currentProductPage,
                    layout: "pager, sizes",
                    total: _ctx.totalProductRows,
                    onCurrentChange: _ctx.handleCurrentChange,
                    onSizeChange: _ctx.handleSizeChange,
                    onPrevClick: ($event: any) => (1)
                  }, null, 8, ["page-size", "current-page", "total", "onCurrentChange", "onSizeChange"])
                ])
              ])
            ]))
  ], 64))
})